/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { RegistryOfficeType } from '../../models/registry-office-type';

export interface OfficeControllerDeleteTypes$Params {
  idType: number;
}

export function officeControllerDeleteTypes(http: HttpClient, rootUrl: string, params: OfficeControllerDeleteTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeType;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerDeleteTypes.PATH, 'delete');
  if (params) {
    rb.path('idType', params.idType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryOfficeType;
      }>;
    })
  );
}

officeControllerDeleteTypes.PATH = '/registry/office/types/{idType}';
